<div class="div-message-box animated fadeIn fast">
  <div class="message-box-container animated fadeIn fast">
    <div class="message-box-middle">
      <span class="msg-title">
        <i class="fa fa-sign-out txt-color-orange-dark"></i>{{ header }}
      </span>
      <p class="p-text">{{ message }}</p>
      <div class="message-box-button-section">
        <button class="btn btn-default btn-xs" (click)="onCancel()">No</button>
        <button class="btn btn-danger btn-xs" (click)="onSaveWithGlobalIssue()">Save with {{ globalIssue }}</button>
        <button class="btn btn-danger btn-xs" (click)="onSaveWithRowIssue()">Save with {{ rowIssue }}</button>
      </div>
    </div>
  </div>
</div>
